<template>
  <div class="image-container">
    <img class="product-img" v-if="image" :src="image ? image.image_url : ''">
    <div v-else>
      {{ $t('ChargingStationImage.no_image_available') }}{{ currentBuild }}
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'ChargingStationImage',
  computed: {
      ...mapGetters({
        image: 'images/getBuildImage',
      }),
      currentBuild() {
        const getters = this.$store.getters;
        const build = this.$store.state.build;

        let name = '';
        name += getters['types/current'] ? getters['types/current'].name : '';
        name += ' ' + (getters['types/chosenProperty']('colors', build.color, 'name'));
        name += ' ' + (getters['methods/current'] ? getters['methods/current'].name : '');
        name += ' ' + (getters['methods/currentPlug'] ? getters['methods/currentPlug'].name : '');
        name += ' ' + (getters['types/chosenProperty']('systems', build.system, 'name'));

        return name;
      }
  },
}
</script>


<style scoped lang="scss">
.image-container {
  padding: 10px;

  img {
    max-width: 100%;
    height: auto;
    max-height: 100%;
  }
}
</style>
